import React__default, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@sravni/react-design-system/lib/Button';
import { LockedError, TooManyRequestsError, BadRequestError } from '@sravni/utils/lib/errors/network';
import { DEFAULT_ERROR_MESSAGE } from '../../constansts/index.js';
import { joinRetryAfterAndErrorType, getWindowLocation } from '../../helpers/utils.js';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';
import { useSendOtpByPhoneNumber } from '../../hooks/useSendOtpByPhoneNumber.js';

const DEFAULT_CHILDREN = 'Получить код';
const GetOTPButton = React__default.forwardRef((props, ref) => {
    const { onClick: onClickOutside, children = DEFAULT_CHILDREN, ...rest } = props;
    const returnUrl = getWindowLocation();
    const { watch, setError, clearErrors, trigger } = useFormContext();
    const [isLoading, setIsLoading] = useIsLoading();
    const sendOtpByPhoneNumber = useSendOtpByPhoneNumber();
    const phone = watch("phone" /* FIELD_NAME.PHONE */);
    const name = watch("name" /* FIELD_NAME.NAME */);
    const handleClick = useCallback(async (event) => {
        event.preventDefault();
        clearErrors();
        const isValidFields = await trigger(["email" /* FIELD_NAME.EMAIL */, "name" /* FIELD_NAME.NAME */, "phone" /* FIELD_NAME.PHONE */]);
        if (!isValidFields)
            return;
        onClickOutside?.(event);
        setIsLoading(true);
        try {
            await sendOtpByPhoneNumber({ phone, name, returnUrl });
        }
        catch (error) {
            if (error instanceof LockedError) {
                setError("root.server" /* FIELD_NAME.SERVER */, { message: 'Данный аккаунт был заблокирован, попробуйте войти позже.' });
                return;
            }
            if (error instanceof TooManyRequestsError) {
                const { retryAfter } = error;
                if (!retryAfter) {
                    setError("phone" /* FIELD_NAME.PHONE */, { message: `Слишком много попыток, попробуйте позднее` });
                    return;
                }
                setError("phone" /* FIELD_NAME.PHONE */, {
                    type: joinRetryAfterAndErrorType(retryAfter),
                    message: `Слишком много попыток, попробуйте снова через`,
                });
                return;
            }
            if (error instanceof BadRequestError) {
                const { target = "root.server" /* FIELD_NAME.SERVER */ } = error;
                setError(target, { message: error?.message || DEFAULT_ERROR_MESSAGE });
                return;
            }
            setError("root.server" /* FIELD_NAME.SERVER */, { message: DEFAULT_ERROR_MESSAGE });
        }
        finally {
            setIsLoading(false);
        }
    }, [clearErrors, name, onClickOutside, phone, returnUrl, sendOtpByPhoneNumber, setError, setIsLoading, trigger]);
    return (React__default.createElement(Button, { block: true, ref: ref, size: 60, variant: "primary", color: "gray", ...rest, type: "submit", onClick: handleClick, loading: isLoading, disabled: isLoading }, children));
});

export { GetOTPButton };
//# sourceMappingURL=view.js.map
